<template>
    <div>

        <Head title="Routes" />
        <h1 class="mb-4 text-3xl font-bold">
            <Link class="text-sky-400 hover:text-sky-600" :href="`/`"> 
                Dashboard/  
            </Link>
            Ruta {{ nameRoute.description }} {{ formatDate(routeJourney.start_date)  }}</h1>
        
        <div class="flex items-center justify-between p-4 mt-5 mb-5 bg-sky-600 rounded-2xl">
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Encargado: <b>{{nameUser}}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Tiendas abiertas: <b>{{storeOpenedVisited.length }}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2 ">Tiendas cerradas: <b>{{storeClosedVisited.length}}</b> </p>
            </div>
            <div class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Total pedido: <b>${{total_order()}}</b> </p>
            </div>
            <div v-if="routeJourney.status===0" class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Status: <b> Finalizada</b> </p>
            </div>
            <div v-else class="bg-white  rounded-2xl ">
            <p class="text-1xl m-2">Status: <b> Activa</b> </p>
            </div>
            
            
            
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto rounded-2xl">
            <GMapMap :center="center" :zoom="15" map-type-id="roadmap" style="width: 100%; height:30vw">
                <GMapMarker :key="index" v-for="(m, index) in markersClosedVisited" :position="m.position" :clickable="true" :icon="'../../../img/icon_not_open_store.png'"
                    :draggable="false" @click="openMarker(m.id)">
                    <GMapInfoWindow :closeclick="true" @closeclick="openMarker(null)" :opened="openedMarkerID === m.id">
                        <div style="width: 250px; height: 100px;">
                            <p style="font-size: large; background-color: salmon; border-radius: 10px; display: flex; justify-content: center; text-align: center;" ><strong style=" display: flex; text-align: center;">CERRADA</strong></p>
                            <p style="font-size: medium; margin-top: 15px;" ><b>Tienda:  {{ m.description }}</b></p>
                            <p style="font-size: medium; margin-top: 15px;" ><i>Visitada:  {{ m.visit_date }}</i></p>
                             </div>
                    </GMapInfoWindow>
                </GMapMarker>
                <GMapMarker :key="index" v-for="(m, index) in markersOpenedVisited" :position="m.position" :clickable="true" :icon="'../../../img/icon_open_store.png'"
                    :draggable="false" @click="openMarker(m.id)">
                    <GMapInfoWindow :closeclick="true" @closeclick="openMarker(null)" :opened="openedMarkerID === m.id">
                        <div style="width: 250px; height: 140px;">
                            <p style="color: white; font-size: large; background-color: green; border-radius: 10px; display: flex; justify-content: center; text-align: center;" ><strong style=" display: flex; text-align: center;">ABIERTA</strong></p>
                            <p style="font-size: medium; margin-top: 15px;" ><b>Tienda:  {{ m.description }}</b></p>
                            <p style="font-size: medium; margin-top: 15px;" ><b>Pedido:  ${{ suma(m.id_route_client) }}</b></p>
                            <p style="font-size: medium; margin-top: 15px;" ><i>Visitada:  {{ m.visit_date }}</i></p>
                             </div>
                    </GMapInfoWindow>
                </GMapMarker>
                <GMapPolyline :path="path" :editable="false" :options="polylineOptions"/>
            </GMapMap>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Search from '@/Shared/Search'
import DialogInput from '@/Shared/Dialog'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import InputFile from '@/Shared/InputFile'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'


export default {
    components: {
        Head,
        Link,
        Search,
        DialogInput,
        LoadingButton,
        TextInput,
        Icon,
        Pagination,
        SelectInput,
        TextareaInput,
        InputFile,

    },
    layout: Layout,
    props: {
        storeClosedVisited: Array,
        storeOpenedVisited: Array,
        orders: Array,
        routeJourney:Array,
        nameRoute: Array,
        nameUser: String,
        points:Array
    },
    remember: 'form',
    data() {
        return {
            openedMarkerID: null,
            center: { lat: 17.073312511352395, lng: -96.72620363783986 },//17.073312511352395, -96.72620363783986
            markersClosedVisited: this.storeClosedVisited,
            markersOpenedVisited: this.storeOpenedVisited,
            path: this.points,
            polylineOptions: {
        strokeColor: '#035DC3',       // Color de la línea
        strokeOpacity: 0.8,           // Opacidad de la línea
        strokeWeight: 4               // Ancho de la línea
      }   
        }
    },
    created() {
    this.markersClosedVisited = this.storeClosedVisited.map(store => ({
      ...store,
      position: {
        lat: Number( store.latitude),
        lng: Number(store.longitude)
      }
    }));
    this.markersOpenedVisited = this.markersOpenedVisited.map(store => ({
      ...store,
      position: {
        lat: Number( store.latitude),
        lng: Number(store.longitude)
      }
    }));
  },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/routes', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        openMarker(id) {
            this.openedMarkerID = id
        },
        suma(numero){
            let total = 0;
            this.orders.forEach(objeto => {
                if (objeto.id_route_client === numero) {
                total += objeto.amount * objeto.price;
            }
            })
            return total.toFixed(2);
        },
        total_order(){
            let total = 0;
            this.orders.forEach(objeto => {
                
                total += objeto.amount * objeto.price;
            
            })
            return total.toFixed(2);
        },
        formatDate(date_str){
            const date_route = new Date(date_str)
            const day_date_route = date_route.getDate().toString().padStart(2,'0')
            const month_date_route = (date_route.getMonth()+1).toString().padStart(2,'0')
            const year_date_route = date_route.getFullYear()

            return `${day_date_route}/${month_date_route}/${year_date_route}`
        }
    },
}
</script>
